/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { createEntity, getEntity, reset, updateEntity } from './user-additional-history.reducer';

export const UserAdditionalHistoryUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const doctors = useAppSelector(state => state.doctor.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const userAdditionalHistoryEntity = useAppSelector(state => state.userAdditionalHistory.entity);
  const loading = useAppSelector(state => state.userAdditionalHistory.loading);
  const updating = useAppSelector(state => state.userAdditionalHistory.updating);
  const updateSuccess = useAppSelector(state => state.userAdditionalHistory.updateSuccess);

  const handleClose = () => {
    navigate(`/user-additional-history${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDoctors({}));
    dispatch(getGlucoUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cataractSurgery !== undefined && typeof values.cataractSurgery !== 'number') {
      values.cataractSurgery = Number(values.cataractSurgery);
    }
    if (values.tonsillectomy !== undefined && typeof values.tonsillectomy !== 'number') {
      values.tonsillectomy = Number(values.tonsillectomy);
    }
    if (values.cholecystestomy !== undefined && typeof values.cholecystestomy !== 'number') {
      values.cholecystestomy = Number(values.cholecystestomy);
    }
    if (values.heartSurgery !== undefined && typeof values.heartSurgery !== 'number') {
      values.heartSurgery = Number(values.heartSurgery);
    }
    if (values.hysterectomy !== undefined && typeof values.hysterectomy !== 'number') {
      values.hysterectomy = Number(values.hysterectomy);
    }
    if (values.herniaRepair !== undefined && typeof values.herniaRepair !== 'number') {
      values.herniaRepair = Number(values.herniaRepair);
    }
    if (values.hipReplacement !== undefined && typeof values.hipReplacement !== 'number') {
      values.hipReplacement = Number(values.hipReplacement);
    }
    if (values.kneeReplacement !== undefined && typeof values.kneeReplacement !== 'number') {
      values.kneeReplacement = Number(values.kneeReplacement);
    }
    if (values.appendectomy !== undefined && typeof values.appendectomy !== 'number') {
      values.appendectomy = Number(values.appendectomy);
    }
    if (values.tmDate !== undefined && typeof values.tmDate !== 'number') {
      values.tmDate = Number(values.tmDate);
    }
    if (values.userdate11 !== undefined && typeof values.userdate11 !== 'number') {
      values.userdate11 = Number(values.userdate11);
    }
    if (values.userdate12 !== undefined && typeof values.userdate12 !== 'number') {
      values.userdate12 = Number(values.userdate12);
    }
    if (values.userdate13 !== undefined && typeof values.userdate13 !== 'number') {
      values.userdate13 = Number(values.userdate13);
    }
    if (values.userdate14 !== undefined && typeof values.userdate14 !== 'number') {
      values.userdate14 = Number(values.userdate14);
    }
    if (values.userdate15 !== undefined && typeof values.userdate15 !== 'number') {
      values.userdate15 = Number(values.userdate15);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }

    const entity = {
      ...userAdditionalHistoryEntity,
      ...values,
      consultant: doctors.find(it => it.id.toString() === values.consultant?.toString()),
      glucoUser: glucoUsers.find(it => it.id.toString() === values.glucoUser?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...userAdditionalHistoryEntity,
          consultant: userAdditionalHistoryEntity?.consultant?.id,
          glucoUser: userAdditionalHistoryEntity?.glucoUser?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.userAdditionalHistory.home.createOrEditLabel" data-cy="UserAdditionalHistoryCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.home.createOrEditLabel">
              Create or edit a UserAdditionalHistory
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="user-additional-history-id"
                  label={translate('tinyMedicRestApp.userAdditionalHistory.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.coffee')}
                id="user-additional-history-coffee"
                name="coffee"
                data-cy="coffee"
                type="textarea"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.tobacco')}
                id="user-additional-history-tobacco"
                name="tobacco"
                data-cy="tobacco"
                type="textarea"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.alcohol')}
                id="user-additional-history-alcohol"
                name="alcohol"
                data-cy="alcohol"
                type="textarea"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.sleepPatterns')}
                id="user-additional-history-sleepPatterns"
                name="sleepPatterns"
                data-cy="sleepPatterns"
                type="textarea"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.exercisePatterns')}
                id="user-additional-history-exercisePatterns"
                name="exercisePatterns"
                data-cy="exercisePatterns"
                type="textarea"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.seatbeltUse')}
                id="user-additional-history-seatbeltUse"
                name="seatbeltUse"
                data-cy="seatbeltUse"
                type="textarea"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.counseling')}
                id="user-additional-history-counseling"
                name="counseling"
                data-cy="counseling"
                type="textarea"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.hazardousActivities')}
                id="user-additional-history-hazardousActivities"
                name="hazardousActivities"
                data-cy="hazardousActivities"
                type="textarea"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.recreationalDrugs')}
                id="user-additional-history-recreationalDrugs"
                name="recreationalDrugs"
                data-cy="recreationalDrugs"
                type="textarea"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.recentBreastExam')}
                id="user-additional-history-recentBreastExam"
                name="recentBreastExam"
                data-cy="recentBreastExam"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.recentMammogram')}
                id="user-additional-history-recentMammogram"
                name="recentMammogram"
                data-cy="recentMammogram"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.recentGynocologicalExam')}
                id="user-additional-history-recentGynocologicalExam"
                name="recentGynocologicalExam"
                data-cy="recentGynocologicalExam"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.recentRectalExam')}
                id="user-additional-history-recentRectalExam"
                name="recentRectalExam"
                data-cy="recentRectalExam"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.recentProstateExam')}
                id="user-additional-history-recentProstateExam"
                name="recentProstateExam"
                data-cy="recentProstateExam"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.recentPhysicalExam')}
                id="user-additional-history-recentPhysicalExam"
                name="recentPhysicalExam"
                data-cy="recentPhysicalExam"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.recentSigmoidoscopyColonoscopy')}
                id="user-additional-history-recentSigmoidoscopyColonoscopy"
                name="recentSigmoidoscopyColonoscopy"
                data-cy="recentSigmoidoscopyColonoscopy"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.recentEcg')}
                id="user-additional-history-recentEcg"
                name="recentEcg"
                data-cy="recentEcg"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.recentCardiacEcho')}
                id="user-additional-history-recentCardiacEcho"
                name="recentCardiacEcho"
                data-cy="recentCardiacEcho"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.recentRetinal')}
                id="user-additional-history-recentRetinal"
                name="recentRetinal"
                data-cy="recentRetinal"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.recentFluvax')}
                id="user-additional-history-recentFluvax"
                name="recentFluvax"
                data-cy="recentFluvax"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.recentPneuvax')}
                id="user-additional-history-recentPneuvax"
                name="recentPneuvax"
                data-cy="recentPneuvax"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.recentLdl')}
                id="user-additional-history-recentLdl"
                name="recentLdl"
                data-cy="recentLdl"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.recentHemoglobin')}
                id="user-additional-history-recentHemoglobin"
                name="recentHemoglobin"
                data-cy="recentHemoglobin"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.recentPsa')}
                id="user-additional-history-recentPsa"
                name="recentPsa"
                data-cy="recentPsa"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.recentExamResults')}
                id="user-additional-history-recentExamResults"
                name="recentExamResults"
                data-cy="recentExamResults"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.historyMother')}
                id="user-additional-history-historyMother"
                name="historyMother"
                data-cy="historyMother"
                type="textarea"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.dcMother')}
                id="user-additional-history-dcMother"
                name="dcMother"
                data-cy="dcMother"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.historyFather')}
                id="user-additional-history-historyFather"
                name="historyFather"
                data-cy="historyFather"
                type="textarea"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.dcFather')}
                id="user-additional-history-dcFather"
                name="dcFather"
                data-cy="dcFather"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.historySiblings')}
                id="user-additional-history-historySiblings"
                name="historySiblings"
                data-cy="historySiblings"
                type="textarea"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.dcSiblings')}
                id="user-additional-history-dcSiblings"
                name="dcSiblings"
                data-cy="dcSiblings"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.historyOffspring')}
                id="user-additional-history-historyOffspring"
                name="historyOffspring"
                data-cy="historyOffspring"
                type="textarea"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.dcOffspring')}
                id="user-additional-history-dcOffspring"
                name="dcOffspring"
                data-cy="dcOffspring"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.historySpouse')}
                id="user-additional-history-historySpouse"
                name="historySpouse"
                data-cy="historySpouse"
                type="textarea"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.dcSpouse')}
                id="user-additional-history-dcSpouse"
                name="dcSpouse"
                data-cy="dcSpouse"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.relativesCancer')}
                id="user-additional-history-relativesCancer"
                name="relativesCancer"
                data-cy="relativesCancer"
                type="textarea"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.relativesTuberculosis')}
                id="user-additional-history-relativesTuberculosis"
                name="relativesTuberculosis"
                data-cy="relativesTuberculosis"
                type="textarea"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.relativesDiabetes')}
                id="user-additional-history-relativesDiabetes"
                name="relativesDiabetes"
                data-cy="relativesDiabetes"
                type="textarea"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.relativesHighBloodPressure')}
                id="user-additional-history-relativesHighBloodPressure"
                name="relativesHighBloodPressure"
                data-cy="relativesHighBloodPressure"
                type="textarea"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.relativesHeartProblems')}
                id="user-additional-history-relativesHeartProblems"
                name="relativesHeartProblems"
                data-cy="relativesHeartProblems"
                type="textarea"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.relativesStroke')}
                id="user-additional-history-relativesStroke"
                name="relativesStroke"
                data-cy="relativesStroke"
                type="textarea"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.relativesEpilepsy')}
                id="user-additional-history-relativesEpilepsy"
                name="relativesEpilepsy"
                data-cy="relativesEpilepsy"
                type="textarea"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.relativesMentalIllness')}
                id="user-additional-history-relativesMentalIllness"
                name="relativesMentalIllness"
                data-cy="relativesMentalIllness"
                type="textarea"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.relativesSuicide')}
                id="user-additional-history-relativesSuicide"
                name="relativesSuicide"
                data-cy="relativesSuicide"
                type="textarea"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.cataractSurgery')}
                id="user-additional-history-cataractSurgery"
                name="cataractSurgery"
                data-cy="cataractSurgery"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.tonsillectomy')}
                id="user-additional-history-tonsillectomy"
                name="tonsillectomy"
                data-cy="tonsillectomy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.cholecystestomy')}
                id="user-additional-history-cholecystestomy"
                name="cholecystestomy"
                data-cy="cholecystestomy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.heartSurgery')}
                id="user-additional-history-heartSurgery"
                name="heartSurgery"
                data-cy="heartSurgery"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.hysterectomy')}
                id="user-additional-history-hysterectomy"
                name="hysterectomy"
                data-cy="hysterectomy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.herniaRepair')}
                id="user-additional-history-herniaRepair"
                name="herniaRepair"
                data-cy="herniaRepair"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.hipReplacement')}
                id="user-additional-history-hipReplacement"
                name="hipReplacement"
                data-cy="hipReplacement"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.kneeReplacement')}
                id="user-additional-history-kneeReplacement"
                name="kneeReplacement"
                data-cy="kneeReplacement"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.appendectomy')}
                id="user-additional-history-appendectomy"
                name="appendectomy"
                data-cy="appendectomy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.tmDate')}
                id="user-additional-history-tmDate"
                name="tmDate"
                data-cy="tmDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.name1')}
                id="user-additional-history-name1"
                name="name1"
                data-cy="name1"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.value1')}
                id="user-additional-history-value1"
                name="value1"
                data-cy="value1"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.name2')}
                id="user-additional-history-name2"
                name="name2"
                data-cy="name2"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.value2')}
                id="user-additional-history-value2"
                name="value2"
                data-cy="value2"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.additionalHistory')}
                id="user-additional-history-additionalHistory"
                name="additionalHistory"
                data-cy="additionalHistory"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.exams')}
                id="user-additional-history-exams"
                name="exams"
                data-cy="exams"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.usertext11')}
                id="user-additional-history-usertext11"
                name="usertext11"
                data-cy="usertext11"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.usertext12')}
                id="user-additional-history-usertext12"
                name="usertext12"
                data-cy="usertext12"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.usertext13')}
                id="user-additional-history-usertext13"
                name="usertext13"
                data-cy="usertext13"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.usertext14')}
                id="user-additional-history-usertext14"
                name="usertext14"
                data-cy="usertext14"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.usertext15')}
                id="user-additional-history-usertext15"
                name="usertext15"
                data-cy="usertext15"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.usertext16')}
                id="user-additional-history-usertext16"
                name="usertext16"
                data-cy="usertext16"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.usertext17')}
                id="user-additional-history-usertext17"
                name="usertext17"
                data-cy="usertext17"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.usertext18')}
                id="user-additional-history-usertext18"
                name="usertext18"
                data-cy="usertext18"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.usertext19')}
                id="user-additional-history-usertext19"
                name="usertext19"
                data-cy="usertext19"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.usertext20')}
                id="user-additional-history-usertext20"
                name="usertext20"
                data-cy="usertext20"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.usertext21')}
                id="user-additional-history-usertext21"
                name="usertext21"
                data-cy="usertext21"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.usertext22')}
                id="user-additional-history-usertext22"
                name="usertext22"
                data-cy="usertext22"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.usertext23')}
                id="user-additional-history-usertext23"
                name="usertext23"
                data-cy="usertext23"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.usertext24')}
                id="user-additional-history-usertext24"
                name="usertext24"
                data-cy="usertext24"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.usertext25')}
                id="user-additional-history-usertext25"
                name="usertext25"
                data-cy="usertext25"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.usertext26')}
                id="user-additional-history-usertext26"
                name="usertext26"
                data-cy="usertext26"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.usertext27')}
                id="user-additional-history-usertext27"
                name="usertext27"
                data-cy="usertext27"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.usertext28')}
                id="user-additional-history-usertext28"
                name="usertext28"
                data-cy="usertext28"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.usertext29')}
                id="user-additional-history-usertext29"
                name="usertext29"
                data-cy="usertext29"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.usertext30')}
                id="user-additional-history-usertext30"
                name="usertext30"
                data-cy="usertext30"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.userdate11')}
                id="user-additional-history-userdate11"
                name="userdate11"
                data-cy="userdate11"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.userdate12')}
                id="user-additional-history-userdate12"
                name="userdate12"
                data-cy="userdate12"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.userdate13')}
                id="user-additional-history-userdate13"
                name="userdate13"
                data-cy="userdate13"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.userdate14')}
                id="user-additional-history-userdate14"
                name="userdate14"
                data-cy="userdate14"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.userdate15')}
                id="user-additional-history-userdate15"
                name="userdate15"
                data-cy="userdate15"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.userarea11')}
                id="user-additional-history-userarea11"
                name="userarea11"
                data-cy="userarea11"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.userarea12')}
                id="user-additional-history-userarea12"
                name="userarea12"
                data-cy="userarea12"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.timestampentry')}
                id="user-additional-history-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.active')}
                id="user-additional-history-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.lastupdated')}
                id="user-additional-history-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.cursor')}
                id="user-additional-history-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAdditionalHistory.microSec')}
                id="user-additional-history-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="user-additional-history-consultant"
                name="consultant"
                data-cy="consultant"
                label={translate('tinyMedicRestApp.userAdditionalHistory.consultant')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="user-additional-history-glucoUser"
                name="glucoUser"
                data-cy="glucoUser"
                label={translate('tinyMedicRestApp.userAdditionalHistory.glucoUser')}
                type="select"
                required
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/user-additional-history" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default UserAdditionalHistoryUpdate;
